// Need a context that components across the React tree can consume
import { createContext } from "react";

const QdtContext = createContext();

export default QdtContext;
